// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    MenuItem,
    Divider,
    Autocomplete,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    List,
    ListItem,
    Select as MUISelect
} from '@mui/material';
import { ManageAccounts, Cancel, ArrowBack } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import TasklistFilter from './TasklistFilter';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { borderRadius, color, height, padding, width } from '@mui/system';
import Select, { SingleValue } from "react-select";
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { useTranslation } from "react-i18next";
import { DateTimePicker, LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        //   margin: theme.spacing(2),

        //   '&.Mui-disabled': {
        //     border: 0,
        //   },
        '&:not(:first-of-type)': {
            borderRadius: theme.shape.borderRadius
        },
        '&:first-of-type': {
            borderRadius: theme.shape.borderRadius
        }
    }
}));

const StyledToggleButton = styled(ToggleButton)({
    border: 2,
    borderColor: deepPurple[500],
    backgroundColor: grey[300],
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: deepPurple[500]
    }
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1200,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px',
    height: '100%'
};

const confirmModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
];

const GroupBuyingModal = ({
    groupBuyingModalOpen,
    setGroupBuyingModalOpen,
    activeTab,
    buttonName,
    customerRow,
    fetchCustomers,
    handleRefresh
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [view, setView] = useState('allTasks');
    const [customerID, setCustomerID] = useState(0);

    const [depositAmount, setDepositAmount] = useState(0);
    const [withdrawalAmount, setWithdrawalAmount] = useState(0);
    const [vipLevelID, setVIPLevelID] = useState(0);
    const [depositTabUpdateButtonDisabled, setDepositTabUpdateButtonDisabled] = useState(false);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChange = (event, nextView) => {
        setView(nextView);
    };

    const handleOpenModal = () => {
        setView(activeTab);
        setGroupBuyingModalOpen(true);
    };

    useEffect(() => {
        if (groupBuyingModalOpen && customerRow?.id) {
            setCustomerID(customerRow.id);
            setView(activeTab); // or set to 'resetTasklist' by default
        }
    }, [groupBuyingModalOpen, customerRow]);

    function AllGroupBuyingTab() {
        const [openConfirmModal, setOpenConfirmModal] = useState(false);
        const [deleteCustomerPoolDisabled, setDeleteCustomerPoolDisabled] = useState(false);
        const [selectedCustomerPoolId, setSelectedCustomerPoolId] = useState(null);
        const [selectedCustomerContributorPoolID, setSelectedCustomerContributorPoolID] = useState(null);
        const [selectedUpdateProfitPoolID, setSelectedUpdateProfitPoolID] = useState(null);
        const [selectedUpdateProfitCustomerID, setSelectedUpdateProfitCustomerID] = useState(null);

        const [openUpdateTotalProfitModal, setOpenUpdateTotalProfitModal] = useState(false);
        const [updateTotalProfitDisabled, setUpdateTotalProfitDisabled] = useState(false);

        const [openContributorsModal, setOpenContributorsModal] = useState(false);

        const [totalProfitAmount, setTotalProfitAmount] = useState(0);

        useEffect(() => {
            fetchCustomerPool();
        }, []);

        const [customerPool, setCustomerPool] = useState([]);
        const fetchCustomerPool = async () => {
            try {
                const res = await axiosInstance.get(`/CustomerPool?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setCustomerPool(res.data);
                }
            } catch (error) {

            }
        };

        const submitDeleteCustomerPool = async () => {
            setDeleteCustomerPoolDisabled(true);

            try {
                const res = await axiosInstance.post(
                    `/DeleteCustomerPool?id=${selectedCustomerPoolId}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功取消拼单');
                    fetchCustomerPool();
                    setOpenConfirmModal(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setDeleteCustomerPoolDisabled(false);
            }
        };

        const submitUpdateProfitAmount = async () => {
            try {
                const res = await axiosInstance.put(
                    '/Backend/CustomerPool/TotalProfitAmount',
                    {
                        poolID: selectedUpdateProfitPoolID,
                        totalProfitAmount: totalProfitAmount,
                        customerID: selectedUpdateProfitCustomerID
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更改顾客盈利数额');
                    handleRefresh();
                    setEditCustomerModalOpen(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateButtonDisabled(false);
            }
        };

        return (
            <>
                <Modal
                    open={openConfirmModal}
                    onClose={() => setOpenConfirmModal(false)}
                    aria-labelledby="modal-modal-title2"
                    aria-describedby="modal-modal-description2"
                >
                    <Box sx={confirmModalStyle}>
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: '25px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    marginTop: '30px'
                                }}
                            >
                                {t("pool.confirmDeleteCustomerPool")} ?
                            </Typography>
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        display: 'block',
                                        mx: 'auto',
                                        width: '150px',
                                        backgroundColor: deepPurple[500],
                                        marginTop: '30px'
                                    }}
                                    onClick={submitDeleteCustomerPool}
                                    disabled={deleteCustomerPoolDisabled}
                                >
                                    {t("customer.confirm")}
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        display: 'block',
                                        mx: 'auto',
                                        width: '150px',
                                        backgroundColor: 'grey',
                                        marginTop: '30px'
                                    }}
                                    onClick={() => setOpenConfirmModal(false)}
                                    disabled={deleteCustomerPoolDisabled}
                                >
                                    {t("customer.cancel")}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
                <Modal
                    open={openUpdateTotalProfitModal}
                    onClose={() => setOpenUpdateTotalProfitModal(false)}
                    aria-labelledby="modal-modal-title2"
                    aria-describedby="modal-modal-description2"
                >
                    <Box sx={confirmModalStyle}>
                        <Box>
                            <TextField
                                required
                                label={t("pool.profitAmount")}
                                name="totalProfitAmount"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                fullWidth
                                variant="outlined"
                                value={totalProfitAmount}
                                onChange={(e) => setTotalProfitAmount(e.target.value)}
                            />
                            <Typography
                                sx={{
                                    fontSize: '25px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    marginTop: '30px'
                                }}
                            >
                                {t("pool.confirmUpdateCustomerProfitAmount")} ?
                            </Typography>
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        display: 'block',
                                        mx: 'auto',
                                        width: '150px',
                                        backgroundColor: deepPurple[500],
                                        marginTop: '30px'
                                    }}
                                    onClick={submitUpdateProfitAmount}
                                    disabled={updateTotalProfitDisabled}
                                >
                                    {t("customer.confirm")}
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        display: 'block',
                                        mx: 'auto',
                                        width: '150px',
                                        backgroundColor: 'grey',
                                        marginTop: '30px'
                                    }}
                                    onClick={() => setOpenUpdateTotalProfitModal(false)}
                                    disabled={updateTotalProfitDisabled}
                                >
                                    {t("customer.cancel")}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
                <Modal
                    open={openContributorsModal}
                    onClose={() => setOpenContributorsModal(false)}
                    aria-labelledby="modal-modal-title2"
                    aria-describedby="modal-modal-description2"
                >
                    <Box sx={confirmModalStyle}>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                {t("pool.contributors")}:
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Client Name</strong></TableCell>
                                            <TableCell align="right"><strong>Contribute Amount</strong></TableCell>
                                            <TableCell align="right"><strong>Profit</strong></TableCell>
                                            <TableCell align="right"><strong>Contribute Date</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {customerPool
                                            .find((s) => s.id === selectedCustomerContributorPoolID)
                                            ?.contributorList.map((contributor) => {
                                                return (
                                                    <TableRow key={contributor.id}>
                                                        <TableCell>{contributor.clientName}</TableCell>
                                                        <TableCell align="right">{contributor.contributeAmount}</TableCell>
                                                        <TableCell align="right">{contributor.profitAmount}</TableCell>
                                                        <TableCell align="right">
                                                            {contributor.contributeDateTime.split('T')[0]} {new Date(
                                                                '1970-01-01T' + contributor.contributeDateTime.split('T')[1] + 'Z'
                                                            ).toLocaleTimeString('en-US', {
                                                                timeZone: 'UTC',
                                                                hour12: true,
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric'
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Box>
                </Modal>
                <Box>
                    <TableContainer sx={{ maxHeight: '70vh' }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell key='details' style={{ minWidth: 80 }}>{t("customer.details")}</TableCell>
                                    <TableCell key='eventDetails' style={{ minWidth: 170 }}>{t("pool.eventDetails")}</TableCell>
                                    <TableCell key='profitAmount' style={{ minWidth: 170 }}>{t("pool.profitAmount")}</TableCell>
                                    <TableCell key='customerTotalContributedAmount' style={{ minWidth: 170 }}>{t("pool.customerTotalContributedAmount")}</TableCell>
                                    <TableCell key='action' style={{ minWidth: 170 }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {customerPool.map((row) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                            <TableCell key='details' style={{fontSize: "12px"}}>
                                                {t("pool.poolType")}: {row.typeID === 1 ? t("pool.small") : row.typeID === 2 ? t("pool.medium") : row.typeID === 3 ? t("pool.large") : ""}<br/>
                                                {
                                                    row.createdDate && 
                                                    <>
                                                        {t("customer.createdAt")} 
                                                        {row.createdDate.split('T')[0]} {new Date(
                                                            '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                                        ).toLocaleTimeString('en-US', {
                                                            timeZone: 'UTC',
                                                            hour12: true,
                                                            hour: 'numeric',
                                                            minute: 'numeric',
                                                            second: 'numeric'
                                                        })}
                                                    </>
                                                }
                                            </TableCell>
                                            <TableCell key='eventDetails' style={{fontSize: "12px"}}>
                                                {t("pool.eventStartDate")} : {' '}
                                                    {row.eventStartDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.eventStartDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}<br/>
                                                {t("pool.eventEndDate")} : {' '}
                                                    {row.eventEndDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.eventEndDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}<br/>
                                                {t("pool.eventCompletedDate")} : {' '}
                                                    {row.eventCompletedDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.eventCompletedDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}<br/>
                                                {t("pool.poolSizeAmount")}: {row.poolSizeAmount}<br/>
                                                {t("pool.estimatedTotalPoolProfitAmount")}: {row.totalPoolProfitAmount}<br/>
                                                {t("pool.presetContributorSet")}: {row.contributorSetName}
                                            </TableCell>
                                            <TableCell key='profitAmount' style={{fontSize: "12px"}}>
                                                {row.totalProfitAmount}
                                            </TableCell>
                                            <TableCell key='profitAmount' style={{fontSize: "12px"}}>
                                                {row.customerTotalContributedAmount}
                                            </TableCell>
                                            <TableCell key='action' style={{fontSize: "12px"}}>
                                                <Button
                                                    sx={{
                                                        display: 'block',
                                                        width: '150px',
                                                        backgroundColor: deepPurple[500],
                                                        marginTop: '20px',
                                                        marginBottom: '30px'
                                                    }}
                                                    variant="contained"
                                                    onClick={() => {
                                                        setSelectedCustomerContributorPoolID(row.id);
                                                        setOpenContributorsModal(true);
                                                    }}
                                                >
                                                    {t("pool.contributorsList")}
                                                </Button>
                                                <Button
                                                    sx={{
                                                        display: 'block',
                                                        width: '150px',
                                                        backgroundColor: '#ef6339',
                                                        marginTop: '20px',
                                                        marginBottom: '30px'
                                                    }}
                                                    variant="contained"
                                                    onClick={() => {
                                                        setSelectedUpdateProfitPoolID(row.id);
                                                        setOpenUpdateTotalProfitModal(true);
                                                        setSelectedUpdateProfitCustomerID(row.customerID);
                                                    }}
                                                >
                                                    {t("pool.updateCustomerProfitAmount")}
                                                </Button>
                                                <Button
                                                    sx={{
                                                        display: 'block',
                                                        width: '150px',
                                                        backgroundColor: 'red',
                                                        marginTop: '20px',
                                                        marginBottom: '30px'
                                                    }}
                                                    variant="contained"
                                                    onClick={() => {
                                                        setSelectedCustomerPoolId(row.id);
                                                        setOpenConfirmModal(true);
                                                    }}
                                                >
                                                    {t("customer.cancel")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </>
        );
    }

    function InsertPoolTab() {
        useEffect(() => {
            fetchPoolTypes();
        },[]);

        const [poolSizeAmount, setPoolSizeAmount] = useState(0);
        const [eventStartDate, setEventStartDate] = useState(dayjs());
        const [eventEndDate, setEventEndDate] = useState(dayjs());
        const [eventCompletedDate, setEventCompletedDate] = useState(dayjs());
        const [totalProfitAmount, setTotalProfitAmount] = useState(0);
        const [selectedPoolTypeID, setSelectedPoolTypeID] = useState('');
        const [presetContributorList, setPresetContributorList] = useState([]);
        const [selectedSetID, setSelectedSetID] = useState(null);
        const [totalPoolProfitAmount, setTotalPoolProfitAmount] = useState(0);

        const [insertCustomerPoolButtonDisabled, setInsertCustomerPoolButtonDisabled] = useState(false);

        const submitInsertCustomerPool = async () => {
            if (insertCustomerPoolButtonDisabled) return;

            setInsertCustomerPoolButtonDisabled(true);

            const eventStartDatePart = dayjs(eventStartDate.$d).format('YYYY-MM-DD');
            const eventStartTimePart = dayjs(eventStartDate.$d).format('HH:mm:00');
            const finalEventStartDate = `${eventStartDatePart}T${eventStartTimePart}`;


            const eventEndDatePart = dayjs(eventEndDate.$d).format('YYYY-MM-DD');
            const eventEndTimePart = dayjs(eventEndDate.$d).format('HH:mm:00');
            const finalEventEndDate = `${eventEndDatePart}T${eventEndTimePart}`;

            const eventCompletedDatePart = dayjs(eventCompletedDate.$d).format('YYYY-MM-DD');
            const eventCompletedTimePart = dayjs(eventCompletedDate.$d).format('HH:mm:00');
            const finalEventCompletedDate = `${eventCompletedDatePart}T${eventCompletedTimePart}`;

            const isEndAfterStart = dayjs(finalEventEndDate).isAfter(dayjs(finalEventStartDate));
            const isCompletedAfterBoth = dayjs(finalEventCompletedDate).isAfter(dayjs(finalEventStartDate)) &&
                                        dayjs(finalEventCompletedDate).isAfter(dayjs(finalEventEndDate));

            if (!isEndAfterStart) {
                errorAlert('Event end date/time must be after start date/time.');
                setInsertCustomerPoolButtonDisabled(false);
                return;
            }

            if (!isCompletedAfterBoth) {
                errorAlert('Event completed date/time must be after both start and end date/time.');
                setInsertCustomerPoolButtonDisabled(false);
                return;
            }

            try {
                const res = await axiosInstance.post(
                    '/CustomerPool',
                    {
                        customerID: customerRow.id,
                        typeID: selectedPoolTypeID ? parseInt(selectedPoolTypeID) : 0,
                        eventStartDate: finalEventStartDate,
                        eventEndDate: finalEventEndDate,
                        eventCompletedDate: finalEventCompletedDate,
                        totalProfitAmount: totalProfitAmount ? parseFloat(totalProfitAmount) : 0,
                        poolSizeAmount: poolSizeAmount ? parseFloat(poolSizeAmount) : 0,
                        contributorSetID: selectedSetID ? parseInt(selectedSetID) : 0,
                        totalPoolProfitAmount: totalPoolProfitAmount ? parseFloat(totalPoolProfitAmount) : 0,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功保存');
                    fetchPresetContributorList();
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertCustomerPoolButtonDisabled(false);
            }
        };

        const [allPoolTypes, setAllPoolTypes] = useState([]);
        const fetchPoolTypes = async () => {
            try {
                const res = await axiosInstance.get(`/PoolType/All`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setAllPoolTypes(res.data);
                }
            } catch (error) {

            }
        };

        const fetchPresetContributorList = async (poolTypeID) => {
            try {
                const res = await axiosInstance.get(`/Backend/PresetPoolContributorList/ByPoolTypeID?poolTypeID=${poolTypeID}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setPresetContributorList(res.data);
                }
            } catch (error) {

            }
        };
        
        useEffect(() => {
            fetchPresetContributorList(selectedPoolTypeID);
        },[selectedPoolTypeID]);

        const handleSelectedPoolType = async (poolTypeID) => {
            setSelectedPoolTypeID(poolTypeID);

            const selectedPool = allPoolTypes.find(pool => pool.id === poolTypeID);
            if (selectedPool){
                setPoolSizeAmount(selectedPool.poolSizeAmount);
            }
        };

        return (
            <Box style={{height: '80vh'}}>
                <Grid item container sx={{ mt: 2 }}>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {/* <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="utc">
                                <DatePicker
                                    label={t("pool.eventStartDate")}
                                    sx={{
                                        width: '100%'
                                    }}
                                    value={matchDate}
                                    onChange={(newValue) => {
                                        setMatchDate(newValue);
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label={t("pool.eventStartDate")}
                                    sx={{ width: '100%' }}
                                    value={matchTime}
                                    onChange={(newValue) => {
                                        setMatchTime(newValue);
                                    }}
                                />
                            </LocalizationProvider> */}
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label={t("pool.eventStartDate")}
                                    value={eventStartDate}
                                    onChange={(newValue) => setEventStartDate(newValue)}
                                    renderInput={(props) => <TextField {...props} />}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label={t("pool.eventEndDate")}
                                    value={eventEndDate}
                                    onChange={(newValue) => setEventEndDate(newValue)}
                                    renderInput={(props) => <TextField {...props} />}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    required
                                    label={t("pool.eventCompletedDate")}
                                    value={eventCompletedDate}
                                    onChange={(newValue) => setEventCompletedDate(newValue)}
                                    renderInput={(props) => <TextField {...props} />}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                </Grid>
                <Grid item container sx={{ mt: 2 }}>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FormControl fullWidth>
                                <MUISelect
                                    required
                                    displayEmpty
                                    value={selectedPoolTypeID || ""}
                                     onChange={(e) => handleSelectedPoolType(e.target.value)}
                                    sx={{
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        '& .MuiSelect-select': {
                                            fontSize: '13px',
                                            padding: '10px 14px',
                                        },
                                        '& .MuiInputBase-root': {
                                            fontSize: '13px',
                                            minHeight: '36px',
                                            padding: '10px 14px',
                                        },
                                    }}
                                >
                                    <MenuItem value="">{t("pool.pleaseSelectPoolType")}</MenuItem>
                                    {allPoolTypes?.map((item, index) => (
                                        <MenuItem value={item.id} key={index}>
                                            {item.id === 1 ? t("pool.small") : item.id === 2 ? t("pool.medium") : item.id === 3 ? t("pool.large") : ''}
                                        </MenuItem>
                                    ))}
                                </MUISelect>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <TextField
                                required
                                name="totalProfitAmount"
                                label={t("pool.profitAmount")}
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={totalProfitAmount}
                                onChange={(e) => setTotalProfitAmount(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        submitInsertCustomerPool();
                                    }
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <TextField
                                required
                                name="totalPoolProfitAmount"
                                label={t("pool.estimatedTotalPoolProfitAmount")}
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={totalPoolProfitAmount}
                                onChange={(e) => setTotalPoolProfitAmount(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        submitInsertCustomerPool();
                                    }
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <TextField
                                required
                                name="poolSizeAmount"
                                label={t("pool.poolSizeAmount")}
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={poolSizeAmount}
                                onChange={(e) => setPoolSizeAmount(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        submitInsertCustomerPool();
                                    }
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mt: 4 }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("pool.pleaseSelectPresetContributorSet")}</FormLabel>
                        <RadioGroup
                            row
                            value={selectedSetID}
                            onChange={(e) => setSelectedSetID(Number(e.target.value))}
                        >
                            {presetContributorList.map((set) => (
                                <FormControlLabel
                                    key={set.setID}
                                    value={set.setID}
                                    control={<Radio />}
                                    label={set.setName}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {
                    selectedSetID && 
                    (
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                {t("pool.contributors")}:
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Sequence</strong></TableCell>
                                            <TableCell><strong>Client Name</strong></TableCell>
                                            <TableCell><strong>Login User Name</strong></TableCell>
                                            <TableCell><strong>Customer Code</strong></TableCell>
                                            <TableCell align="right"><strong>Amount</strong></TableCell>
                                            <TableCell align="right"><strong>Interval (s)</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {presetContributorList
                                            .find((s) => s.setID === selectedSetID)
                                            ?.contributors.map((contributor) => {
                                                // const eventStartDatePart = dayjs(eventStartDate.$d).format('YYYY-MM-DD');
                                                // const eventStartTimePart = dayjs(eventStartDate.$d).format('HH:mm:00');
                                                // const finalEventStartDate = `${eventStartDatePart}T${eventStartTimePart}`;

                                                // const eventStartDate2 = new Date(finalEventStartDate); // Assuming this is a valid date
                                                // const intervalSeconds = contributor.intervalSeconds;

                                                // Add intervalSeconds to eventStartDate
                                                // const updatedDate = new Date(eventStartDate2.getTime() + intervalSeconds * 1000); // Add seconds
                                                // const updatedDatePart = dayjs(updatedDate.$d).format('YYYY-MM-DD');
                                                // const updatedTimePart = dayjs(updatedDate.$d).format('HH:mm:ss');
                                                // const finalUpdatedDate = `${updatedDatePart}T${updatedTimePart}`;

                                                return (
                                                    <TableRow key={contributor.id}>
                                                        <TableCell>{contributor.sequenceNumber}</TableCell>
                                                        <TableCell>{contributor.clientName}</TableCell>
                                                        <TableCell>{contributor.customerLoginUserName}</TableCell>
                                                        <TableCell>{contributor.customerNumberCode}</TableCell>
                                                        <TableCell align="right">{contributor.contributeAmount}</TableCell>
                                                        <TableCell align="right">{contributor.intervalSeconds}</TableCell>
                                                        {/* <TableCell align="right">
                                                            {finalUpdatedDate.split('T')[0]} {new Date(
                                                                '1970-01-01T' + finalUpdatedDate.split('T')[1] + 'Z'
                                                            ).toLocaleTimeString('en-US', {
                                                                timeZone: 'UTC',
                                                                hour12: true,
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric'
                                                            })}
                                                        </TableCell> */}
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    )
                }
                <br/>
                <Divider />
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '40px'
                    }}
                    onClick={() => submitInsertCustomerPool()}
                    disabled={insertCustomerPoolButtonDisabled}
                >
                    {t("customer.save")}
                </Button>
            </Box>
        );
    }

    function ComboTaskHistoryTab() {
        const [presetCustomerTasklist, setPresetCustomerTasklist] = useState([]);
        const [refreshButtonDisabled, setRefreshButtonDisabled] = useState(false);

        const fetchData = async () => {
            try {
                const res = await axiosInstance.get(`/Customer/PresetCustomerTasklist/All?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setPresetCustomerTasklist(res.data);
                }
            } catch (error) {

            }
        };

        useEffect(() => {
            fetchData();
        }, []);

        return (
            <Box>
                <Box style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                    <Button
                        variant="contained"
                        sx={{
                            width: '100px',
                            backgroundColor: deepPurple[500]
                        }}
                        onClick={() => fetchData()}
                        disabled={refreshButtonDisabled}
                    >
                        {t("customer.refresh")}
                    </Button>
                </Box>
                <TableContainer sx={{ maxHeight: '70vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key='details' style={{ minWidth: 80 }}>{t("customer.details")}</TableCell>
                                <TableCell key='commissionPercentage' style={{ minWidth: 170 }}>{t("customer.price")}</TableCell>
                                <TableCell key='price' style={{ minWidth: 170 }}>{t("customer.profit")}</TableCell>
                                <TableCell key='estimatedNegativeAmount' style={{ minWidth: 170 }}>{t("customer.status")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {presetCustomerTasklist.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell key='details' style={{fontSize: "12px"}}>
                                            {t("customer.taskNumber1")}{row.taskNumber}{t("customer.taskNumber2")}<br/>
                                            {row.taskName}<br/>
                                            {
                                                row.createdDate && 
                                                <>
                                                    {t("customer.createdAt")} 
                                                    {row.createdDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                </>
                                            } <br/>
                                            {
                                                row.updatedDate && 
                                                <>
                                                    {t("customer.updatedAt")}
                                                    {row.updatedDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.updatedDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                </>
                                            }
                                            
                                        </TableCell>
                                        <TableCell key='commissionPercentage' style={{fontSize: "12px"}}>
                                            {t("customer.price")} : {row.amount}<br/>
                                        </TableCell>
                                        <TableCell key='price' style={{fontSize: "12px"}}>
                                            {t("customer.taskCommission")} : {row.commissionPercentage}<br/>
                                            {t("customer.profit")} : {row.profit}
                                        </TableCell>
                                        <TableCell key='estimatedNegativeAmount' style={{fontSize: "12px", fontWeight: 'bolder', color: row.statusID === 1 ? 'orange' : row.statusID === 2 ? 'green' : ''}}>
                                            {row.statusID === 1 && (t("customer.processing"))}
                                            {row.statusID === 2 && (t("customer.completed"))}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }

    return (
        <>
            <Modal
                open={groupBuyingModalOpen}
                onClose={() => setGroupBuyingModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("pool.pool")}
                        </Typography>
                        <Cancel onClick={() => setGroupBuyingModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Box
                        id="modal-modal-description"
                        sx={{
                            overflowY: 'auto'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%' 
                            }}
                        >
                            <StyledToggleButtonGroup
                                value={view}
                                exclusive
                                onChange={handleChange}
                                sx={{
                                    flexDirection: { xs: 'column', md: 'row' }
                                }}
                            >
                                <StyledToggleButton value="allGroupBuying" aria-label="allGroupBuying">
                                    {t("pool.allGroupBuying")}
                                </StyledToggleButton>
                                <StyledToggleButton value="insertPool" aria-label="insertPool">
                                    {t("pool.insertPool")}
                                </StyledToggleButton>
                            </StyledToggleButtonGroup>
                        </Box>
            
                        {view === 'allGroupBuying' && (
                            <>
                                <AllGroupBuyingTab />
                            </>
                        )}
                        {view === 'insertPool' && (
                            <>
                                <InsertPoolTab />
                            </>
                        )}
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default GroupBuyingModal;